<template>
  <b-card>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <b-button class="m-1" variant="primarySpore" @click="back()">Regresar</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <feather-icon v-b-tooltip.hover.left title="Editar" icon="EditIcon" @click="edit = true" class="float-right cursor-pointer" svgClasses="hover:text-primary" v-if="!edit" />
      </b-col>
    </b-row>

    <div v-if="!edit">
      <b-row class="m-2">
        <b-col cols="12" md="3">
          <h4>Número: </h4> {{response.number}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Nombre: </h4> {{response.name}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Teléfono: </h4> {{response.phone}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Correo electrónico: </h4> {{response.email}}
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col cols="12" md="3">
          <h4>Encargado: </h4> {{response.manager}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Meta de Instalación: </h4> {{response.goal}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Poligono: </h4> {{response.polygon}}
        </b-col>
        <b-col cols="12" md="3">
          <h4>Acrónimo: </h4> {{response.acronym}}
        </b-col>
      </b-row>
      <b-row class="m-2">
        <b-col cols="12" md="3">
          <h4>Zona: </h4> {{ (response.cfeZone != null ? response.cfeZone.name : '') }}
        </b-col>
      </b-row>
    </div>

    <b-form class="m-2" v-if="show">
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Número *" label-for="number">
            <b-form-input id="number" v-model="response.number" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Nombre *" label-for="name">
            <b-form-input id="name" v-model="response.name" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Teléfono" label-for="phone">
            <b-form-input id="phone" v-model="response.phone" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Correo electrónico" label-for="email">
            <b-form-input id="email" v-model="response.email" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Encargado" label-for="manager">
            <b-form-input id="manager" v-model="response.manager" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Meta de Instalación" label-for="goal">
            <b-form-input id="goal" v-model="response.goal" trim></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Polígono" label-for="polygon">
            <b-form-input id="polygon" v-model="response.polygon" trim></b-form-input>
            </b-form-group>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-group label="Acrónimo *" label-for="acronym">
            <b-form-input id="acronym" v-model="response.acronym" trim></b-form-input>
            </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="edit === true">
        <b-col cols="12" md="3">
          <b-form-group label="Zona *" label-for="zona" >
            <v-select input-id="zona" :options="listZonas" :clearable="false" v-model="selectedZone" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div v-if="edit">
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">Guardar</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">Cancelar</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput, VBTooltip
} from 'bootstrap-vue'

import request from '@/libs/request/index'

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      listZonas: [{ title: '', value: '', label: '' }],
      selectedZone: {},
      edit: false,
      uuid: this.$route.params.uuid,
      response: {},
      show: true
    }
  },
  methods: {
    cancel () {
      this.edit = false
      this.getDetail()
    },
    async getZonas () {
      const params = {
        url: '/zones',
        method: 'GET',
        params: { divisionUuid: this.$store.state.session.AppActiveUser().division.uuid }
      }
      await request(params).then(data => {
        if (data.status === 200) {
          for (const item of data.data) {
            this.listZonas.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    back () {
      this.$router.push('/agencies')
    },
    async getDetail () {
      const params = {
        url: `/agencies/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]

          if (this.response.cfeZone != null) {
            this.selectedZone = {
              title: this.response.cfeZone.name,
              value: this.response.cfeZone.uuid,
              label: this.response.cfeZone.name
            }
          }
        }
      })
    },
    async save () {
      if (this.response.number === '' || this.response.name === '' || this.selectedZone.value === '' || this.selectedZone.value === undefined || this.response.acronym === '') {
        this.$swal({
          title: 'Favor de ingresar los datos requeridos',
          text: '',
          timer: 5000,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-warning'
          },
          buttonsStyling: false
        })
      } else {
        const divisionUuid = this.$store.state.session.AppActiveUser().division.uuid
        const params = {
          url: `/agencies/${this.uuid}`,
          method: 'PUT',
          params: {
            number: this.response.number,
            name: this.response.name,
            phone: this.response.phone,
            email: this.response.email,
            manager: this.response.manager,
            goal: this.response.goal,
            polygon: this.response.polygon,
            acronym: this.response.acronym,
            zoneUuid: this.selectedZone.value,
            divisionUuid
          }
        }
        await request(params).then(data => {
          this.edit = false
          this.getDetail()
        })
      }
    }
  },
  created () {
    this.getDetail()
    this.getZonas()
  }
}
</script>
